export default __webpack_public_path__ + "static/banner-stores-desktop-6f7f966a323df0d01d16de971ee2f2bd.webp";